import { render } from "./UserPage.vue?vue&type=template&id=a5135b72&scoped=true"
import script from "./UserPage.vue?vue&type=script&lang=js"
export * from "./UserPage.vue?vue&type=script&lang=js"

import "./UserPage.vue?vue&type=style&index=0&id=a5135b72&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE\\zoopay\\zoopay\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5135b72"]])

export default __exports__